export default "__VITE_ASSET__BBy70e9w__"